import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { ExchangeProtectionController } from '../controller/ExchangeProtectionController';

export class ExchangeProtectionWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ExchangeProtectionController,
    });
  }
}
